export const ConsumerRouteResolverMessages = {
  loadingMessage: {
    id: 'Pages.ConsumerRouteResolver.loadingMessage',
    description: 'loading message for consumer route resolver',
  },
}
